package com.patronat.top.features.dashboard.presentation.contract

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.core.navigation.DashboardSection
import com.patronat.top.dto.DashboardStatsResponse

object DashboardContract {

    data class State(
        val isLoading: Boolean = true,
        val isStatsLoading: Boolean = false,
        val user: User? = null,
        val dashboardStats: DashboardStatsResponse? = null,
        val currentSection: DashboardSection = DashboardSection.DASHBOARD
    ) : ViewState

    sealed interface Event : ViewEvent {
        data class OnMenuSelected(val section: DashboardSection) : Event
        data object OnRetryClick : Event
    }

    sealed interface Effect : ViewSideEffect {
        data object NavigateToAuth : Effect
    }
}
